import { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import Select from 'react-select';
import CurrencyInput from 'react-currency-input-field';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { setAlert } from '../../actions/alert';
import { crearLocatario } from '../../actions/locatarios';
import { buscarServiciosConfiguracion } from '../../actions/configuracion';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const NuevoLocatario = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Locatarios',
            path: '/locatarios'
        },
        {
            activo: true,
            nombre: 'Nuevo locatario',
            path: '/locatarios/nuevo'
        }
    ];

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const servicios = useSelector(state => state.configuracion.servicios);

    const [locatarioData, setLocatarioData] = useState({
        nombre: null,
        servicio: null,
        monto_renta: null,
        intervalo_cita: null,
        descripcion: null,
        metodos_pago: [],
        servicios: [],
        horarios: [
            [],
            [],
            [],
            [],
            [],
            [],
            []
        ]
    });

    const [servicioData, setServicioData] = useState(null);
    const [serviciosFilter, setServiciosFilter] = useState([]);

    const [metodosPagoData, setMetodosPagoData] = useState([]);
    const metodosPagoOptions = [
        { value: 0, label: 'Efectivo' },
        { value: 1, label: 'Tarjeta' },
        { value: 2, label: 'Transferencia' }
    ];

    const [intervalosCitaData, setIntervalosCitaData] = useState([]);
    const intervalosCitasFilter = [
        { value: 15, label: '15 minutos' }, 
        { value: 30, label: '30 minutos' }, 
        { value: 45, label: '45 minutos' }, 
        { value: 60, label: '1 hora' }, 
        { value: 90, label: '1 hora y media' }, 
        { value: 120, label: '2 horas' }, 
        { value: 150, label: '2 horas y media' }
    ];

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided, 
        }),
        control: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Nuevo locatario */
    const handleInputChange = ({ target }) => {
        setLocatarioData({
            ...locatarioData,
            [target.name]: target.value
        });
    }

    const handleSelectServicio = (option) => {
        setServicioData(option);

        setLocatarioData({
            ...locatarioData,
            servicio: option != null ? option.value : null
        });
    }

    const handleSelectMetodosPago = (options) => {
        setMetodosPagoData(options || []);

        setLocatarioData({
            ...locatarioData,
            metodos_pago: options ? options.map(o => o.value) : []
        });
    }

    const handleRentaChange = (value) => {
        setLocatarioData({
            ...locatarioData,
            monto_renta: value || ''
        });
    }

    /* Servicios */
    const handleAgregarServicio = () => {
        let servicios = locatarioData.servicios;

        servicios.push({
            nombre: null, 
            precio: 0, 
            intervalo_cita: 15
        });

        setLocatarioData({ 
            ...locatarioData, 
            servicios
        });
    }

    const handlePrecioServicioChange = (posicion, value) => {
        let servicios = locatarioData.servicios;

        servicios[posicion].precio = value || '';

        setLocatarioData({
            ...locatarioData,
            servicios
        });
    }

    const handleNombreServicioChange = ({ target }) => {
        let nombre_separado = target.name.split('_');

        let posicion = nombre_separado[1];
        
        let servicios = locatarioData.servicios;

        servicios[posicion].nombre = target.value || '';

        setLocatarioData({
            ...locatarioData,
            servicios
        });
    }

    const handleIntervaloServicioChange = (value, action) => {
        let nombre_separado = action.name.split('_');

        let posicion = nombre_separado[1];

        let servicios = locatarioData.servicios;
        let intervalos_elegidos = intervalosCitaData;

        servicios[posicion].intervalo_cita = value?.value != null && value?.value != undefined ? value?.value : 15;
        intervalos_elegidos[posicion] = value;

        setIntervalosCitaData(intervalos_elegidos);

        setLocatarioData({
            ...locatarioData,
            servicios
        });
    }

    const handleEliminarServicio = async ({ currentTarget }) => {
        let id_separado = currentTarget.id.split('_');    

        let servicios = locatarioData.servicios;

        servicios.splice(id_separado[1], 1);

        setLocatarioData({ 
            ...locatarioData, 
            servicios
        });
    }

    /* Horarios */
    const handleAgregarHorario = (dia) => {
        let horarios = locatarioData.horarios;

        horarios[dia].push({
            dia, 
            hora_inicio: '12:00',
            hora_fin: '12:00'
        });

        setLocatarioData({
            ...locatarioData,
            horarios
        });
    }

    const handleChangeTime = (posicion, dia, hora, tipo) => {
        let horarios = locatarioData.horarios;

        if(tipo == 1){
            horarios[dia][posicion] = {
                ...horarios[dia][posicion], 
                hora_inicio: hora
            };
        }else{
            horarios[dia][posicion] = {
                ...horarios[dia][posicion], 
                hora_fin: hora
            };
        }

        setLocatarioData({
            ...locatarioData,
            horarios
        });
    }

    const handleEliminarTime = (dia, posicion) => {
        let horarios = locatarioData.horarios;

        horarios[dia].splice(posicion, 1);

        setLocatarioData({
            ...locatarioData,
            horarios
        });
    }

    const handleGuardarLocatario = async () => {
        if(locatarioData.nombre){
            await dispatch(crearLocatario(locatarioData));

            await navigate("/locatarios");
        }else{
            await dispatch(setAlert('Todos los campos son obligatorios', 'danger'));
        }
    }

    /* Funciones generales */   
    const createFilasServicios = (servicios) => {

        let servicios_campos = [];

        if(servicios){
            for (let x = 0; x < servicios?.length; x++) {
                servicios_campos.push(
                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group h-100">
                            <div className="input-group-preppend w-20">
                                <div className="input-group">
                                    <div className="form-floating">
                                        <CurrencyInput
                                            id="precio"
                                            name="precio"
                                            className="form-control text-center"
                                            value={servicios[x].precio || ''}
                                            decimalsLimit={2}
                                            groupSeparator=","
                                            decimalSeparator="."
                                            onValueChange={(value) => handlePrecioServicioChange(x, value)}
                                        />
                                        <label htmlFor="precio">Precio</label>
                                    </div>
                                </div>
                            </div>
                            <div className="input-group-preppend w-30">
                                <Select
                                    id={'intervaloCita_' + x}
                                    name={'intervaloCita_' + x}
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Intervalo de cita"
                                    options={intervalosCitasFilter}
                                    value={intervalosCitaData[x]}
                                    onChange={handleIntervaloServicioChange}
                                    menuPortalTarget={document.body}
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Nombre" id={'nombreServicio_' + x} name={'nombreServicio_' + x} value={servicios[x].nombre || ''} onChange={e => handleNombreServicioChange(e)}/>
                                <label htmlFor={'nombreServicio_' + x}>Nombre {x + 1}</label>
                            </div>
                            <div className="input-group-append">
                                <button className="btn btn-danger delete" id={'eliminarServicio_' + x} onClick={e => handleEliminarServicio(e)}><i className="fa-solid fa-xmark"></i></button>
                            </div>
                        </div>
                    </div>
                );
            }
        }else{
            servicios_campos.push(
                <div className="col-md-12 pt-3 text-center">
                    <h5>Agrega servicios a ofrecer</h5>
                </div>
            );
        }

        return servicios_campos;
    }

    const createFilasHorarios = (dia) => {

        let horarios_campos = [];

        let horarios = locatarioData.horarios[dia];

        if(horarios?.length > 0){
            for (let x = 0; x < horarios?.length; x++) {
                horarios_campos.push(
                    <div className="col-md-12 mb-3 row" key={'horario_' + dia  + '_' + x}>
                        <div className="col-md-6 form-group">
                            <div className="form-floating">
                                <TimePicker className="form-control text-center" clearAriaLabel="Reestablecer" dateFormat="h:m" value={horarios[x]?.hora_inicio || new Date()} onChange={ time => handleChangeTime(x, dia, time, 1)} />
                                <label className="font-weight-bold">Hora inicial</label>
                            </div>
                        </div>

                        <div className="col-md-6 form-group">
                            <div className="input-group h-100">
                                <div className="form-floating">
                                    <TimePicker className="form-control text-center" clearAriaLabel="Reestablecer" dateFormat="h:m" value={horarios[x]?.hora_fin || new Date()} onChange={ time => handleChangeTime(x, dia, time, 2)} />
                                    <label className="font-weight-bold">Hora final</label>
                                </div>

                                <div className="input-group-append">
                                    <button className="btn btn-danger deleteField" onClick={e => handleEliminarTime(dia, x)}><i className="fa-solid fa-xmark"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }else{
            horarios_campos.push(
                <div className="col-md-12 mt-5 pt-3 text-center" key={'sin_horarios_' + dia}>
                    <h5>Agrega horarios de operación</h5>
                </div>
            );
        }

        return horarios_campos;
    }

    useEffect(() => {
        dispatch(buscarServiciosConfiguracion());
    }, []);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < servicios.listado?.length; i++) {
            options.push({ value: servicios.listado[i]._id, label: servicios.listado[i].nombre });
        }

        setServiciosFilter(options);
    }, [servicios]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);    

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .selectIconos, .select-group {
                            height: 100%;
                        }

                        .delete {
                            padding: 0.39rem 0.70rem !important;
                            border-radius: 0 25% 25% 0 !important;
                            height: 100%;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Nuevo locatario</h3>
                
                    <div className="row">
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={locatarioData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group h-100">
                                <Select
                                    id="servicio"
                                    name="servicio"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Categoria de servicio"
                                    isClearable={true}
                                    options={serviciosFilter}
                                    value={servicioData}
                                    onChange={(value) => handleSelectServicio(value)}
                                    menuPortalTarget={document.body}
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <CurrencyInput
                                        id="monto_renta"
                                        name="monto_renta"
                                        className="form-control text-center"
                                        value={locatarioData.monto_renta || ''}
                                        decimalsLimit={2}
                                        groupSeparator=","
                                        decimalSeparator="."
                                        onValueChange={(value) => handleRentaChange(value)}
                                    />
                                    <label htmlFor="renta">Monto de renta mensual</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group h-100">
                                <Select
                                    id="metodos_pago"
                                    name="metodos_pago"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Métodos de pago"
                                    isMulti
                                    isClearable
                                    options={metodosPagoOptions}
                                    value={metodosPagoData}
                                    onChange={(value) => handleSelectMetodosPago(value)}
                                    menuPortalTarget={document.body}
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <textarea className="form-control textareCampo" placeholder="Descripción" id="descripcion" name="descripcion" value={locatarioData.descripcion} onChange={e => handleInputChange(e)}></textarea>
                                    <label htmlFor="descripcion">Descripción</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="accordion" id="accordionListado">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Servicios a ofrecer
                                </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionListado">
                                <div className="accordion-body row">

                                    <div className="col-md-12 mb-4 text-end">
                                        <button type="button" className="btn btn-primary float-end me-2" onClick={() => handleAgregarServicio()}><i className="fa-solid fa-plus"></i> Servicio</button>
                                    </div>

                                    { createFilasServicios(locatarioData.servicios) }
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingTwo">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                    Horarios de atención
                                </button>
                            </h2>
                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionListado">
                                <div className="accordion-body row">
                                    <div className="col-md-12 mt-2">
                                        <div className="d-flex align-items-start">
                                            <div className="nav flex-column nav-pills me-3" id="dias-tab" role="tablist" aria-orientation="vertical">
                                                <button className="nav-link active" id="dia-lunes-tab" data-bs-toggle="pill" data-bs-target="#dia-lunes" type="button" role="tab" aria-controls="dia-lunes" aria-selected="true">Lunes</button>
                                                <button className="nav-link" id="dia-martes-tab" data-bs-toggle="pill" data-bs-target="#dia-martes" type="button" role="tab" aria-controls="dia-martes" aria-selected="false">Martes</button>
                                                <button className="nav-link" id="dia-miercoles-tab" data-bs-toggle="pill" data-bs-target="#dia-miercoles" type="button" role="tab" aria-controls="dia-miercoles" aria-selected="false">Miercoles</button>
                                                <button className="nav-link" id="dia-jueves-tab" data-bs-toggle="pill" data-bs-target="#dia-jueves" type="button" role="tab" aria-controls="dia-jueves" aria-selected="false">Jueves</button>
                                                <button className="nav-link" id="dia-viernes-tab" data-bs-toggle="pill" data-bs-target="#dia-viernes" type="button" role="tab" aria-controls="dia-viernes" aria-selected="false">Viernes</button>
                                                <button className="nav-link" id="dia-sabado-tab" data-bs-toggle="pill" data-bs-target="#dia-sabado" type="button" role="tab" aria-controls="dia-sabado" aria-selected="false">Sabado</button>
                                                <button className="nav-link" id="dia-domingo-tab" data-bs-toggle="pill" data-bs-target="#dia-domingo" type="button" role="tab" aria-controls="dia-domingo" aria-selected="false">Domingo</button>
                                            </div>
                                            <div className="tab-content w-100">
                                                <div className="tab-pane fade row show active" id="dia-lunes" role="tabpanel" aria-labelledby="dia-lunes-tab">
                                                    <div className="col-md-12 mb-4 text-end">
                                                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarHorario(1)}><i className="fas fa-plus fa-sm"></i> Horario</button>
                                                    </div>

                                                    { createFilasHorarios(1) }
                                                </div>
                                                <div className="tab-pane fade" id="dia-martes" role="tabpanel" aria-labelledby="dia-martes-tab">
                                                    <div className="col-md-12 mb-4 text-end">
                                                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarHorario(2)}><i className="fas fa-plus fa-sm"></i> Horario</button>
                                                    </div>

                                                    { createFilasHorarios(2) }
                                                </div>
                                                <div className="tab-pane fade" id="dia-miercoles" role="tabpanel" aria-labelledby="dia-miercoles-tab">
                                                    <div className="col-md-12 mb-4 text-end">
                                                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarHorario(3)}><i className="fas fa-plus fa-sm"></i> Horario</button>
                                                    </div>

                                                    { createFilasHorarios(3) }
                                                </div>
                                                <div className="tab-pane fade" id="dia-jueves" role="tabpanel" aria-labelledby="dia-jueves-tab">
                                                    <div className="col-md-12 mb-4 text-end">
                                                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarHorario(4)}><i className="fas fa-plus fa-sm"></i> Horario</button>
                                                    </div>

                                                    { createFilasHorarios(4) }
                                                </div>
                                                <div className="tab-pane fade" id="dia-viernes" role="tabpanel" aria-labelledby="dia-viernes-tab">
                                                    <div className="col-md-12 mb-4 text-end">
                                                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarHorario(5)}><i className="fas fa-plus fa-sm"></i> Horario</button>
                                                    </div>

                                                    { createFilasHorarios(5) }
                                                </div>
                                                <div className="tab-pane fade" id="dia-sabado" role="tabpanel" aria-labelledby="dia-sabado-tab">
                                                    <div className="col-md-12 mb-4 text-end">
                                                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarHorario(6)}><i className="fas fa-plus fa-sm"></i> Horario</button>
                                                    </div>

                                                    { createFilasHorarios(6) }
                                                </div>
                                                <div className="tab-pane fade" id="dia-domingo" role="tabpanel" aria-labelledby="dia-domingo-tab">
                                                    <div className="col-md-12 mb-4 text-end">
                                                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarHorario(0)}><i className="fas fa-plus fa-sm"></i> Horario</button>
                                                    </div>

                                                    { createFilasHorarios(0) }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12 mt-4">
                            <button className="btn btn-success float-end" onClick={handleGuardarLocatario}>Guardar</button>
                            <Link to='/locatarios'><button className="btn btn-danger float-end me-2">Cancelar</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default NuevoLocatario;